module.exports = __webpack_public_path__ + "img/Group 427320719@2x.5f6f86f3.png";